export * from './flashDeals';
export * from './mapFlashDealResponse';
